import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="border-t border-gray-100 bg-white px-6 py-3 flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-1.5">
            <div className="w-5 h-5 bg-teal-600 rounded flex items-center justify-center">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <span className="text-[11px] font-bold text-gray-700">Med<span className="text-teal-600">Code</span>Lookup</span>
            <span className="text-[10px] text-gray-400">© {new Date().getFullYear()}</span>
        </div>
        <div className="flex items-center gap-4">
            <Link to="/about" className="text-[11px] text-gray-400 hover:text-teal-600 transition-colors">About</Link>
            <Link to="/ai-tools" className="text-[11px] text-gray-400 hover:text-teal-600 transition-colors">AI Tools</Link>
            <a href="mailto:support@medcodelookup.com" className="text-[11px] text-gray-400 hover:text-teal-600 transition-colors">Support</a>
        </div>
        <p className="text-[10px] text-gray-300">Free medical code lookup · 710,000+ codes</p>
    </footer>
);

export default Footer;